module.exports = __webpack_public_path__ + "img/background.0d4763a6.jpg";